const TERMINAL_PWA_PREFIXES = [
  "/terminal",
  "/admin",
  "/platform",
  "/reception",
  "/mechanic",
  "/tester",
  "/shopkeeper",
  "/shop",
  "/ledger",
  "/employee",
];

const MINI_PWA_PREFIXES = [
  "/mini",
  "/ledger",
];

export const isTerminalPwaRoute = (pathname = "") =>
  [...TERMINAL_PWA_PREFIXES, ...MINI_PWA_PREFIXES].some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const pwaProductName = (pathname = "") => {
  if (MINI_PWA_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) return "Mini";
  return "Terminal";
};
